export const categories = [
  { slug: "all", name: "全部", icon: "ri-apps-2-line" },
  { slug: "guoman", name: "国漫", icon: "ri-flag-2-line" },
  { slug: "riman", name: "日漫", icon: "ri-sun-line" },
  { slug: "hanman", name: "韩漫", icon: "ri-star-line" },
  { slug: "rexue", name: "热血", icon: "ri-fire-line" },
  { slug: "lianai", name: "恋爱", icon: "ri-heart-line" },
  { slug: "gaoxiao", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "xuanhuan", name: "玄幻", icon: "ri-moon-line" },
  { slug: "kehuan", name: "科幻", icon: "ri-rocket-line" },
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "dongzuo", name: "动作", icon: "ri-sword-line" },
  { slug: "dushi", name: "都市", icon: "ri-building-line" },
];

export const mangas = [
  {
    id: 1,
    title: "斗破苍穹",
    author: "天蚕土豆",
    category: "guoman",
    subcategory: "xuanhuan",
    cover: "https://readdy.ai/api/search-image?query=A%20dramatic%20Chinese%20martial%20arts%20fantasy%20illustration%20with%20a%20young%20warrior%20holding%20a%20flaming%20sword%20against%20a%20mountain%20backdrop%2C%20intense%20warm%20tones%2C%20epic%20scale%2C%20stylized%20anime-inspired%20art%2C%20clean%20composition%20on%20soft%20gradient%20background&width=360&height=500&seq=doupo-cangqiong-cover&orientation=portrait",
    rating: 9.7,
    views: "3.2亿",
    status: "连载中",
    updateChapter: "第1256话",
    updateTime: "今天 18:32",
    description: "三十年河东，三十年河西，莫欺少年穷！少年萧炎，在创造了家族空前绝后的修炼纪录后，却遭遇了人生最大的低谷，种种打击接踵而至。就在他即将绝望的时候，一缕幽魂从他手上的戒指里浮现，一扇全新的大门在面前开启...",
    tags: ["玄幻", "热血", "战斗"],
    chapters: 1256,
  },
  {
    id: 2,
    title: "一人之下",
    author: "米二",
    category: "guoman",
    subcategory: "dongzuo",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20Chinese%20supernatural%20action%20illustration%20featuring%20a%20calm-faced%20young%20man%20with%20flowing%20energy%20surrounding%20him%2C%20urban%20setting%20at%20dusk%2C%20stylized%20anime%20art%2C%20muted%20warm%20tones%2C%20clean%20composition&width=360&height=500&seq=yiren-zhixia-cover&orientation=portrait",
    rating: 9.5,
    views: "2.8亿",
    status: "连载中",
    updateChapter: "第687话",
    updateTime: "今天 12:15",
    description: "平凡大学生张楚岚，因为爷爷的坟墓被盗，卷入了异人世界的纷争之中，开始了一段传奇的冒险旅程。在这个充满异能者的世界里，他逐渐揭开了自己身世的秘密...",
    tags: ["动作", "异能", "热血"],
    chapters: 687,
  },
  {
    id: 3,
    title: "鬼灭之刃",
    author: "吾峠呼世晴",
    category: "riman",
    subcategory: "rexue",
    cover: "https://readdy.ai/api/search-image?query=A%20Japanese%20demon%20slayer%20anime-style%20illustration%20with%20a%20young%20swordsman%20wielding%20a%20water-breathing%20katana%2C%20dramatic%20moonlit%20night%20scene%2C%20intense%20warm%20and%20cool%20contrast%2C%20stylized%20art%2C%20clean%20composition&width=360&height=500&seq=guimie-zhiren-cover&orientation=portrait",
    rating: 9.8,
    views: "4.5亿",
    status: "已完结",
    updateChapter: "第205话(完)",
    updateTime: "2024-12-01",
    description: "大正时期，少年灶门炭治郎一家被鬼袭击，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复成人的方法，炭治郎踏上了成为鬼杀队剑士的道路...",
    tags: ["热血", "战斗", "奇幻"],
    chapters: 205,
  },
  {
    id: 4,
    title: "全职高手",
    author: "蝴蝶蓝",
    category: "guoman",
    subcategory: "dushi",
    cover: "https://readdy.ai/api/search-image?query=A%20stylish%20esports-themed%20Chinese%20illustration%20with%20a%20confident%20gamer%20in%20modern%20urban%20setting%2C%20keyboard%20and%20mouse%20in%20focus%2C%20neon-accented%20warm%20lighting%2C%20anime-style%20art%2C%20clean%20composition&width=360&height=500&seq=quanzhi-gaoshou-cover&orientation=portrait",
    rating: 9.6,
    views: "3.1亿",
    status: "连载中",
    updateChapter: "第892话",
    updateTime: "昨天 22:45",
    description: "网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他寄身于一家网吧成了一个小小的网管。但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏...",
    tags: ["游戏", "竞技", "热血"],
    chapters: 892,
  },
  {
    id: 5,
    title: "女神降临",
    author: "猫咪",
    category: "hanman",
    subcategory: "lianai",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20illustration%20with%20a%20stunning%20young%20woman%20doing%20makeup%20in%20front%20of%20a%20vanity%20mirror%2C%20soft%20warm%20pastel%20tones%2C%20delicate%20anime-style%20art%2C%20clean%20elegant%20composition&width=360&height=500&seq=nvshen-jianglin-cover&orientation=portrait",
    rating: 9.3,
    views: "2.1亿",
    status: "已完结",
    updateChapter: "第232话(完)",
    updateTime: "2024-10-15",
    description: "因为外貌而备受欺凌的女高中生任朱静，通过化妆技术华丽变身，成为了校园里的女神。然而，素颜的秘密却时刻威胁着她的校园生活，一场关于美貌与真心的故事就此展开...",
    tags: ["恋爱", "校园", "美妆"],
    chapters: 232,
  },
  {
    id: 6,
    title: "咒术回战",
    author: "芥见下下",
    category: "riman",
    subcategory: "dongzuo",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20Japanese%20supernatural%20action%20illustration%20with%20a%20spiky-haired%20teenager%20surrounded%20by%20cursed%20energy%2C%20urban%20tokyo%20backdrop%2C%20dynamic%20warm%20amber%20lighting%2C%20stylized%20anime%20art%2C%20clean%20composition&width=360&height=500&seq=zhoushu-huizhan-cover&orientation=portrait",
    rating: 9.7,
    views: "3.9亿",
    status: "连载中",
    updateChapter: "第271话",
    updateTime: "今天 09:20",
    description: "高中生虎杖悠仁，在吞下了诅咒之王两面宿傩的手指后，成为了宿傩的容器。从此，他踏上了咒术师的战斗之路，在与诅咒的战斗中不断成长...",
    tags: ["战斗", "奇幻", "黑暗"],
    chapters: 271,
  },
  {
    id: 7,
    title: "狐妖小红娘",
    author: "小新",
    category: "guoman",
    subcategory: "lianai",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20fantasy%20illustration%20with%20a%20beautiful%20fox%20spirit%20girl%20and%20a%20young%20man%20under%20a%20blooming%20cherry%20tree%2C%20soft%20warm%20pink%20and%20gold%20tones%2C%20delicate%20anime-style%20art%2C%20clean%20composition&width=360&height=500&seq=huyao-xiaohongniang-cover&orientation=portrait",
    rating: 9.4,
    views: "2.6亿",
    status: "连载中",
    updateChapter: "第578话",
    updateTime: "昨天 16:50",
    description: "世上有人有妖，妖会与人相恋，妖寿命千万年，人的寿命有限。于是妖痴情，找到狐妖「购买」一项服务，让投胎转世的人回忆起前世的爱...",
    tags: ["恋爱", "奇幻", "古风"],
    chapters: 578,
  },
  {
    id: 8,
    title: "进击的巨人",
    author: "谏山创",
    category: "riman",
    subcategory: "kehuan",
    cover: "https://readdy.ai/api/search-image?query=A%20dramatic%20Japanese%20dark%20fantasy%20illustration%20with%20a%20giant%20titan%20looming%20over%20a%20walled%20city%2C%20soldiers%20with%20maneuver%20gear%20flying%20through%20the%20air%2C%20intense%20warm%20sunset%20tones%2C%20anime-style%20art%2C%20clean%20composition&width=360&height=500&seq=jinji-juren-cover&orientation=portrait",
    rating: 9.9,
    views: "5.2亿",
    status: "已完结",
    updateChapter: "第139话(完)",
    updateTime: "2024-06-20",
    description: "巨人支配着的世界。变成巨人的食物的人类建造起了高达50米的巨大墙壁，以自由为代价，防止了墙外巨人的侵略。少年艾伦·耶格尔向往墙外的世界，发誓要将巨人全部驱逐出去...",
    tags: ["科幻", "黑暗", "战斗"],
    chapters: 139,
  },
  {
    id: 9,
    title: "哑舍",
    author: "玄色",
    category: "guoman",
    subcategory: "xuanyi",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20Chinese%20antique%20shop%20illustration%20with%20a%20handsome%20shopkeeper%20in%20traditional%20robes%20holding%20an%20ancient%20artifact%2C%20warm%20candlelit%20interior%2C%20subtle%20mystical%20atmosphere%2C%20anime-style%20art%2C%20clean%20composition&width=360&height=500&seq=yashe-cover&orientation=portrait",
    rating: 9.2,
    views: "1.8亿",
    status: "连载中",
    updateChapter: "第345话",
    updateTime: "3天前",
    description: "哑舍里的古物，每一件都有着自己的故事，承载了许多年，无人倾听。因为它们都不会说话。默然等待千年，只为再次相遇...",
    tags: ["悬疑", "奇幻", "古风"],
    chapters: 345,
  },
  {
    id: 10,
    title: "间谍过家家",
    author: "远藤达哉",
    category: "riman",
    subcategory: "gaoxiao",
    cover: "https://readdy.ai/api/search-image?query=A%20wholesome%20Japanese%20comedy%20illustration%20with%20a%20fake%20family%20of%20a%20spy%20man%2C%20assassin%20woman%20and%20telepath%20child%20posing%20together%2C%20bright%20warm%20domestic%20setting%2C%20fun%20anime-style%20art%2C%20clean%20composition&width=360&height=500&seq=jiandie-guojiajia-cover&orientation=portrait",
    rating: 9.6,
    views: "3.5亿",
    status: "连载中",
    updateChapter: "第98话",
    updateTime: "今天 07:15",
    description: "为了潜入名校，西国能力最强的间谍「黄昏」被下令组建家庭。但他找到的「女儿」居然是会读心的超能力者，「妻子」是暗杀者？互相隐藏了真实身份的新家庭，面临着各种考验...",
    tags: ["搞笑", "日常", "间谍"],
    chapters: 98,
  },
  {
    id: 11,
    title: "偷偷藏不住",
    author: "竹已",
    category: "hanman",
    subcategory: "lianai",
    cover: "https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20romance%20illustration%20with%20a%20shy%20schoolgirl%20secretly%20looking%20at%20an%20older%20handsome%20boy%20in%20a%20classroom%2C%20soft%20warm%20sunlight%20streaming%20through%20windows%2C%20delicate%20anime-style%20art%2C%20clean%20composition&width=360&height=500&seq=toutou-cangbuzhu-cover&orientation=portrait",
    rating: 9.4,
    views: "2.4亿",
    status: "已完结",
    updateChapter: "第168话(完)",
    updateTime: "2024-09-30",
    description: "桑稚从十三岁开始就偷偷喜欢着哥哥的朋友段嘉许，这份暗恋持续了整整七年。从青涩少女到成熟女性，她的心意始终未变...",
    tags: ["恋爱", "校园", "暗恋"],
    chapters: 168,
  },
  {
    id: 12,
    title: "完美世界",
    author: "辰东",
    category: "guoman",
    subcategory: "xuanhuan",
    cover: "https://readdy.ai/api/search-image?query=A%20grand%20Chinese%20fantasy%20cultivation%20illustration%20with%20a%20powerful%20young%20cultivator%20floating%20above%20clouds%20surrounded%20by%20golden%20energy%2C%20epic%20mountain%20landscape%2C%20warm%20golden%20sunset%20tones%2C%20anime-style%20art%2C%20clean%20composition&width=360&height=500&seq=wanmei-shijie-cover&orientation=portrait",
    rating: 9.5,
    views: "2.9亿",
    status: "连载中",
    updateChapter: "第823话",
    updateTime: "昨天 20:30",
    description: "一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。一个少年从大荒中走出，一切从这里开始...",
    tags: ["玄幻", "修仙", "战斗"],
    chapters: 823,
  },
  {
    id: 13,
    title: "蓝色监狱",
    author: "金城宗幸",
    category: "riman",
    subcategory: "rexue",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20sports%20soccer%20illustration%20with%20intense%20young%20players%20competing%20on%20a%20futuristic%20training%20field%2C%20dramatic%20warm%20stadium%20lighting%2C%20anime-style%20art%2C%20clean%20composition&width=360&height=500&seq=lanse-jianyu-cover&orientation=portrait",
    rating: 9.3,
    views: "1.9亿",
    status: "连载中",
    updateChapter: "第258话",
    updateTime: "今天 14:40",
    description: "为了培养出能带领日本队夺得世界杯的前锋，日本足协展开了一个名为「蓝色监狱」的计划，召集了300名高中生前锋进行残酷的淘汰训练...",
    tags: ["运动", "竞技", "热血"],
    chapters: 258,
  },
  {
    id: 14,
    title: "我独自升级",
    author: "Chugong",
    category: "hanman",
    subcategory: "dongzuo",
    cover: "https://readdy.ai/api/search-image?query=A%20powerful%20Korean%20action%20illustration%20with%20a%20dark-haired%20hunter%20surrounded%20by%20shadow%20soldiers%20in%20a%20dungeon%2C%20dramatic%20warm%20amber%20and%20dark%20contrast%2C%20stylish%20anime-style%20art%2C%20clean%20composition&width=360&height=500&seq=wo-duzi-shengji-cover&orientation=portrait",
    rating: 9.8,
    views: "3.7亿",
    status: "连载中",
    updateChapter: "第201话",
    updateTime: "今天 06:00",
    description: "十多年前，世界各地突然出现了连接异次元的「门」，而人类之中也诞生了被称为「猎人」的超能力者。最弱E级猎人成振宇，在某次突袭任务中濒死后，获得了独一无二的升级系统...",
    tags: ["动作", "奇幻", "升级"],
    chapters: 201,
  },
  {
    id: 15,
    title: "镇魂街",
    author: "许辰",
    category: "guoman",
    subcategory: "dongzuo",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20Chinese%20supernatural%20action%20illustration%20with%20a%20guardian%20spirit%20warrior%20in%20ancient%20armor%20standing%20on%20a%20mystical%20street%2C%20warm%20orange%20lantern%20light%2C%20anime-style%20art%2C%20clean%20composition&width=360&height=500&seq=zhenhunjie-cover&orientation=portrait",
    rating: 9.3,
    views: "2.2亿",
    status: "连载中",
    updateChapter: "第456话",
    updateTime: "2天前",
    description: "普通的应届大学毕业生夏铃，在求职之际，收到了一条奇怪的面试通知，误入了罗刹街。在这个灵魂居住的镇魂街上，她遇到了改变命运的守护灵...",
    tags: ["动作", "奇幻", "热血"],
    chapters: 456,
  },
];

export const reviews = [
  { id: 1, user: "漫迷小明", avatar: "https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime-style%20avatar%20portrait%20of%20a%20young%20boy%2C%20warm%20friendly%20expression%2C%20clean%20minimal%20background&width=80&height=80&seq=avatar-01&orientation=squarish", rating: 5, content: "九妖漫画真的是我用过最好的漫画网站！更新速度快，画质清晰，而且完全免费。下拉式阅读体验太棒了，一口气能看几百话！", date: "2026-07-28" },
  { id: 2, user: "二次元少女", avatar: "https://readdy.ai/api/search-image?query=A%20simple%20cute%20anime-style%20avatar%20portrait%20of%20a%20young%20girl%20with%20pink%20hair%2C%20happy%20smile%2C%20clean%20minimal%20background&width=80&height=80&seq=avatar-02&orientation=squarish", rating: 5, content: "分类特别齐全，国漫日漫韩漫都有，推荐功能也很准，发现了好多好看的漫画！每天必刷的网站！", date: "2026-07-25" },
  { id: 3, user: "热血少年", avatar: "https://readdy.ai/api/search-image?query=A%20simple%20cool%20anime-style%20avatar%20portrait%20of%20a%20teenage%20boy%20with%20spiky%20hair%2C%20determined%20look%2C%20clean%20minimal%20background&width=80&height=80&seq=avatar-03&orientation=squarish", rating: 5, content: "追更提醒功能很好用，再也不用担心错过更新了。漫画资源丰富，想看的都能找到！强烈推荐！", date: "2026-07-20" },
  { id: 4, user: "漫画控", avatar: "https://readdy.ai/api/search-image?query=A%20simple%20stylish%20anime-style%20avatar%20portrait%20of%20a%20young%20woman%20with%20glasses%2C%20gentle%20smile%2C%20clean%20minimal%20background&width=80&height=80&seq=avatar-04&orientation=squarish", rating: 4, content: "页面设计简洁大方，没有烦人的广告弹窗。漫画加载速度也很快，体验非常好！", date: "2026-07-18" },
  { id: 5, user: "追漫达人", avatar: "https://readdy.ai/api/search-image?query=A%20simple%20friendly%20anime-style%20avatar%20portrait%20of%20a%20young%20man%20with%20a%20cap%2C%20cool%20vibe%2C%20clean%20minimal%20background&width=80&height=80&seq=avatar-05&orientation=squarish", rating: 5, content: "从大学开始就在九妖看漫画了，至今已经五年了。看着网站越来越好，资源越来越多，真心推荐给每一位漫画爱好者！", date: "2026-07-15" },
];

export const banners = [
  {
    id: 1,
    title: "斗破苍穹 - 热血回归",
    subtitle: "三十年河东三十年河西，莫欺少年穷！",
    image: "https://readdy.ai/api/search-image?query=A%20dramatic%20Chinese%20martial%20arts%20fantasy%20banner%20illustration%20with%20a%20young%20warrior%20wielding%20flames%20against%20an%20epic%20mountain%20sunset%20backdrop%2C%20warm%20golden%20and%20crimson%20tones%2C%20cinematic%20anime-style%20art%2C%20grand%20scale%2C%20clean%20composition%20suitable%20for%20hero%20banner&width=1600&height=700&seq=banner-01&orientation=landscape",
    link: "/manga/1",
    tag: "热门推荐",
  },
  {
    id: 2,
    title: "我独自升级 - 暗影君主",
    subtitle: "从最弱到最强，一人成军的传奇之路！",
    image: "https://readdy.ai/api/search-image?query=A%20powerful%20dark%20fantasy%20banner%20illustration%20with%20a%20shadow%20monarch%20surrounded%20by%20dark%20soldiers%20in%20an%20epic%20dungeon%20scene%2C%20dramatic%20warm%20amber%20lighting%20contrast%2C%20cinematic%20anime-style%20art%2C%20clean%20composition&width=1600&height=700&seq=banner-02&orientation=landscape",
    link: "/manga/14",
    tag: "韩漫神作",
  },
  {
    id: 3,
    title: "咒术回战 - 涩谷事变",
    subtitle: "诅咒与宿命的终极对决！",
    image: "https://readdy.ai/api/search-image?query=A%20intense%20Japanese%20supernatural%20battle%20banner%20illustration%20with%20jujutsu%20sorcerers%20fighting%20in%20shibuya%20district%2C%20dramatic%20warm%20orange%20and%20dark%20lighting%2C%20cinematic%20anime-style%20art%2C%20clean%20composition&width=1600&height=700&seq=banner-03&orientation=landscape",
    link: "/manga/6",
    tag: "日漫精选",
  },
];

export const navLinks = [
  { name: "首页", path: "/" },
  { name: "国漫推荐", path: "/category/guoman" },
  { name: "日漫精选", path: "/category/riman" },
  { name: "韩漫热门", path: "/category/hanman" },
  { name: "关于我们", path: "/about" },
];

export const siteInfo = {
  name: "九妖漫画网",
  slogan: "免费漫画全集大全免费下拉式追更",
  description: "九妖漫画网提供免费漫画全集大全，免费下拉式追更，好看的国漫推荐、日漫精选、韩漫热门，免费下拉式漫画全集在线阅读，满足漫画爱好者免费阅读需求。",
  email: "contact@jiuyaomh.com",
  wechat: "jiuyaomh",
  qq: "88886666",
  year: 2018,
};